import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import { Pie } from "react-chartjs-2";
import 'chartjs-plugin-datalabels'; 
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import Page from "../Page";

const genPieData = () => {
  return {
    labels: ['Cash', 'Credit Card', 'eWallet', 'Cheque', 'Others'],
    datasets: [
      {
        label: 'Payment Mode',
        data: [50000, 20000, 4000, 30000, 5000],
        backgroundColor: [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  }
};

const TodayCollection = () => (
  // <div style={{width:"100%"},{textAlign:"center"}}>
  //   <div className='header'>
  //     <h1 className='title'>Todays Collection</h1>
  //   </div>
  //   <div style={{width:"800px"}}>
  //     <Pie data={genPieData()} />
  //   </div>
  // </div>

  <Page title="Todays Collection">
    <Row>
      <Col xl={10} lg={10} md={10}>
        <Card>
            {/* <CardHeader>Todays Collection</CardHeader> */}
          <CardBody>
            <Pie data={genPieData()} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Page>
);

export default TodayCollection;



// WEBPACK FOOTER //
// ./src/components/reports/TodayCollection.js